import { Grid, makeStyles } from "@material-ui/core";

import AdmissibilityNotes from "./expanded-row/AdmissibilityNotes";
import Company from "./expanded-row/Company";
import Docs from "./expanded-row/Docs";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    "& > ul.MuiList-root": {
      whiteSpace: "nowrap",
      borderRight: 1,
      borderRightColor: theme.palette.divider,
      borderRightStyle: "solid",
      width: 200,
    },
  },
}));

const ExpandedRow = ({ record }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <AdmissibilityNotes record={record} />
      <Company record={record} source="company" />
      <Company record={record} source="partner" />
      <Docs record={record} filter={(doc) => doc.type !== 2} />
    </Grid>
  );
};

export default ExpandedRow;
